<h2 class="text-xl font-semibold pb-4" mat-dialog-title>Configure Sidemark Pricing</h2>

<mat-dialog-content>
    <app-project-setting-form
        [isDialogSetting]="true"
    ></app-project-setting-form>
</mat-dialog-content>

<mat-dialog-actions class="flex justify-end py-5 px-6">
    <button type="button" matButton mat-dialog-close class="cta-secondary">Cancel</button>
    <button type="button" matButton class="cta-main" [disabled]="saveDisabled()" (click)="save()">Save Pricing</button>
</mat-dialog-actions>
